export const tokenize = (str: string): string[] =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .split(/\s+/)
    .filter(Boolean);

export const isSimilar = (a: string, b: string, threshold = 0.5): boolean => {
  const aTokens = tokenize(a);
  const bTokens = tokenize(b);
  const matches = aTokens.filter((t) => bTokens.includes(t));
  return matches.length / aTokens.length >= threshold;
};
